import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';


@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  title: string;
  message: string;
  buttonCancel: string;
  buttonConfirm: string;
  outlineButtonConfirm: boolean;
  onlyConfirm:boolean;

  constructor(private modalController: ModalController,  private navParams: NavParams) { }

  ngOnInit() {
    this.title = this.navParams.get('title');
    this.message = this.navParams.get('message');
    this.buttonCancel = this.navParams.get('buttonCancel');
    this.buttonConfirm = this.navParams.get('buttonConfirm');
    this.outlineButtonConfirm = this.navParams.get('outlineButtonConfirm');
    this.onlyConfirm= this.navParams.get('onlyConfirm');
  }

  public cancel() {
    this.modalController.dismiss();
  }

  public confirm() {
    this.modalController.dismiss({confirm: true});
  }

}
